import { ActionService } from 'dashboard-services/services';

export default (() => {

    const EMPTY_USER_METADATA_FIELD = {
      metadataKey: "",
      metadataValue: "",
      isEditable: true,
      isCompanyMetadata: false,
      isEditValueMode: false,
    }

    const ON_CHANGE = "ON_CHANGE_SELECTED_USER_METADATA"
    const onChange = ActionService.makeActionCreator(ON_CHANGE, "value", "name")

    const ADD_SELECTED_USER_METADATA_FIELD = 'ADD_SELECTED_USER_METADATA_FIELD'
    const addUserMetadataField = ActionService.makeActionCreator(ADD_SELECTED_USER_METADATA_FIELD, "id")

    const CHANGE_SELECTED_USER_METADATA_FIELD = 'CHANGE_SELECTED_USER_METADATA_FIELD'
    const changeUserMetadataField = ActionService.makeActionCreator(CHANGE_SELECTED_USER_METADATA_FIELD, 'value', 'name', 'index')

    const REMOVE_SELECTED_USER_METADATA_FIELD = 'REMOVE_SELECTED_USER_METADATA_FIELD'
    const removeUserMetadataField = ActionService.makeActionCreator(REMOVE_SELECTED_USER_METADATA_FIELD, 'index')

    const CLEAN_ALL = 'CLEAN_ALL_SELECTED_USER_METADATA'
    const cleanAll = ActionService.makeActionCreator(CLEAN_ALL)

    return {
      EMPTY_USER_METADATA_FIELD,
      ON_CHANGE,
      onChange,
      addUserMetadataField,
      ADD_SELECTED_USER_METADATA_FIELD,
      changeUserMetadataField,
      CHANGE_SELECTED_USER_METADATA_FIELD,
      removeUserMetadataField,
      REMOVE_SELECTED_USER_METADATA_FIELD,
      cleanAll,
      CLEAN_ALL
    }
})()